var render = function render(){
  var _vm$customerOptions$f, _vm$localState;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "mb-5"
  }, [_vm._m(0), !_vm.isDetail ? [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "font-weight-600 d-block mb-2"
  }, [_vm._v("Customer Type")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-radio', {
    staticClass: "mr-3",
    attrs: {
      "name": "customer-type",
      "value": "active",
      "disabled": _vm.isDetail
    },
    model: {
      value: _vm.localState.customerType,
      callback: function callback($$v) {
        _vm.$set(_vm.localState, "customerType", $$v);
      },
      expression: "localState.customerType"
    }
  }, [_vm._v(" Customer Active ")]), _c('b-form-radio', {
    attrs: {
      "name": "customer-type",
      "value": "prospect",
      "disabled": _vm.isDetail
    },
    model: {
      value: _vm.localState.customerType,
      callback: function callback($$v) {
        _vm.$set(_vm.localState, "customerType", $$v);
      },
      expression: "localState.customerType"
    }
  }, [_vm._v(" Customer Prospect ")])], 1)]), _c('b-col', {
    staticClass: "d-flex align-items-end",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "w-100",
    attrs: {
      "label": "Customer Active Name",
      "label-for": "customer-active",
      "label-class": "font-weight-600"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(" Customer Active Name "), _c('span', {
          staticClass: "text-red"
        }, [_vm._v("*")])])];
      },
      proxy: true
    }], null, false, 1350194120)
  }, [!_vm.isDetail ? [_c('v-select', {
    attrs: {
      "id": "customer-active",
      "options": _vm.customerOptions,
      "disabled": _vm.localState.createNewCustomerProspect,
      "placeholder": "Select Customer",
      "track-by": "id",
      "label": "account_name",
      "required": ""
    },
    model: {
      value: _vm.localState.customerActive,
      callback: function callback($$v) {
        _vm.$set(_vm.localState, "customerActive", $$v);
      },
      expression: "localState.customerActive"
    }
  })] : [_c('p', {
    staticClass: "form-control-plaintext"
  }, [_vm._v(" " + _vm._s(((_vm$customerOptions$f = _vm.customerOptions.find(function (el) {
    return el.value === _vm.localState.customerActive;
  })) === null || _vm$customerOptions$f === void 0 ? void 0 : _vm$customerOptions$f.text) || '-') + " ")])]], 2), !_vm.isDetail && _vm.localState.customerType != 'active' ? _c('b-button', {
    staticClass: "ml-2 mb-3",
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "variant": "primary",
      "disabled": _vm.isDetail
    },
    on: {
      "click": function click($event) {
        _vm.showSidebar = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()], 1)], 1)] : _vm._e(), !_vm.localState.createNewCustomerProspect && (_vm$localState = _vm.localState) !== null && _vm$localState !== void 0 && _vm$localState.customerActive ? _c('div', _vm._l(_vm.infoRows, function (row, idx) {
    return _c('b-row', {
      key: idx,
      staticClass: "mb-3"
    }, [_c('b-col', {
      staticClass: "d-flex justify-content-between",
      attrs: {
        "cols": "5",
        "md": "4"
      }
    }, [_c('span', [_vm._v(_vm._s(row.label))]), _c('span', [_vm._v(":")])]), _c('b-col', {
      attrs: {
        "cols": "7",
        "md": "8"
      }
    }, [_c('span', [_vm._v(_vm._s(row.value || '-'))])])], 1);
  }), 1) : _vm._e(), _c('custom-sidebar', {
    attrs: {
      "size": "80%",
      "title": "New Customer Prospect"
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_vm.showSidebar ? [_c('FormCustomerNew', {
    on: {
      "close": function close($event) {
        _vm.showSidebar = false;
      },
      "submitted": function submitted(val) {
        _vm.$emit('refecthCustomerList', val);
        _vm.localState.customerActive = val.id;
      }
    }
  })] : _vm._e()], 2)], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-title"
  }, [_c('h5', [_vm._v("CUSTOMER INFO")])]);

}]

export { render, staticRenderFns }